import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-ajuda',
  templateUrl: './ajuda.component.html'
})
export class AjudaComponent implements OnInit {

	@Input() id: string;
  @Input() titol: string;  

  constructor(public translate: TranslateService, public modal: ModalService) { }

  ngOnInit(): void {
  }

  open() {
    this.modal.open(this.id);
	}

}
